module.exports = __webpack_public_path__ + "assets/orchard-core.72e7f677.svg";